import { activateShortcutsMenuButton, deactivateShortcutsMenuButton } from './header-bar';
import { closeOverlay, openOverlay } from './overlay';
import { closeAllMenus } from './utils';

const headerShortcutsMenuClass = 'c-header-shortcuts-menu';
const headerShortcutsMenuOpenClass = headerShortcutsMenuClass + '--open';

const headerShortcutsMenuJsClass = 'js-header-shortcuts-menu';

const headerShortcutsMenuElement = document.querySelector('.' + headerShortcutsMenuJsClass) as HTMLElement;

const headerBarJsClass = 'js-header-bar';
const shortcutsMenuButtonJsClass = headerBarJsClass + '-shortcuts-button';

const shortcutsMenuButtonElement = document.querySelector('.' + shortcutsMenuButtonJsClass) as HTMLElement;

if (headerShortcutsMenuElement && shortcutsMenuButtonElement) {
    // We add a custom event listener to close the menu
    document.addEventListener('closeHeaderShortcutsMenu', () => {
        closeHeaderShortcutsMenu();
    });

    // We add click event listener on the menu button
    shortcutsMenuButtonElement.addEventListener('click', () => {
        // If the menu is open
        if (headerShortcutsMenuElement.classList.contains(headerShortcutsMenuOpenClass)) {
            // We close the menu
            closeHeaderShortcutsMenu();
        } else {
            // We open the menu
            openHeaderShortcutsMenu();
        }
    });

    // We add a keydown event listener on the menu
    headerShortcutsMenuElement.addEventListener('keydown', (event) => {
        // If the menu is open and the escape key is pressed
        if (
            event.key === 'Escape'
            && !event.ctrlKey
            && !event.altKey
            && !event.metaKey
            && !event.shiftKey
            && headerShortcutsMenuElement.classList.contains(headerShortcutsMenuOpenClass)
        ) {
            // We close the menu
            closeHeaderShortcutsMenu();
        }
    });

    // We get the links from the menu
    const linkElements = headerShortcutsMenuElement.querySelectorAll('a') as NodeListOf<HTMLAnchorElement>;

    // If there are links in the menu
    if (linkElements.length > 0) {
        // We add a keydown event listener on the first link
        linkElements[0].addEventListener('keydown', (event) => {
            // If the tab and shift keys are down while the first link is focused
            if (
                event.key === 'Tab'
                && !event.ctrlKey
                && !event.altKey
                && !event.metaKey
                && event.shiftKey
            ) {
                // We stop the default behavior
                event.preventDefault();
                // We set the focus on the shortcuts menu button
                shortcutsMenuButtonElement.focus();
                // We close the menu
                closeHeaderShortcutsMenu();
            }
        });

        // We add a keydown event listener on the last link
        linkElements[linkElements.length - 1].addEventListener('keydown', (event) => {
            // If the tab key is down while the last link is focused
            if (
                event.key === 'Tab'
                && !event.ctrlKey
                && !event.altKey
                && !event.metaKey
                && !event.shiftKey
            ) {
                // We stop the default behavior
                event.preventDefault();
                // We set the focus on the shortcuts menu button
                shortcutsMenuButtonElement.focus();
                // We close the menu
                closeHeaderShortcutsMenu();
            }
        });
    }
}

export function openHeaderShortcutsMenu (): void {
    if (!headerShortcutsMenuElement || !shortcutsMenuButtonElement) {
        return;
    }

    // We close all open menus
    closeAllMenus();

    // We activate the button
    activateShortcutsMenuButton();

    // We open the overlay
    openOverlay();

    // If the menu is closed
    if (!headerShortcutsMenuElement.classList.contains(headerShortcutsMenuOpenClass)) {
        // Open menu
        headerShortcutsMenuElement.classList.add(headerShortcutsMenuOpenClass);
        // We set the focus on the first element
        headerShortcutsMenuElement.querySelector('a')?.focus();
    }
}

export function closeHeaderShortcutsMenu (): void {
    if (!headerShortcutsMenuElement || !shortcutsMenuButtonElement) {
        return;
    }

    // We deactivate the button
    deactivateShortcutsMenuButton();

    // We close the overlay
    closeOverlay();

    // If the menu is open
    if (headerShortcutsMenuElement.classList.contains(headerShortcutsMenuOpenClass)) {
        // Close menu
        headerShortcutsMenuElement.classList.remove(headerShortcutsMenuOpenClass);
        // We set focus on the menu button
        shortcutsMenuButtonElement.focus();
    }
}